import React from "react";

const ShareIcons = ({ icon }) => {
  switch (icon) {
    case "messenger":
      return (
        <svg width="36px" height="36px" viewBox="0 0 36 36">
          <g
            id="Symbols"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g id="Artboard" transform="translate(-104.000000, -438.000000)">
              <g id="messenger" transform="translate(104.000000, 438.000000)">
                <circle
                  id="bg"
                  fill="#231F20"
                  cx="17.82"
                  cy="17.82"
                  r="17.82"
                ></circle>
                <path
                  d="M17.82,7.92 C12.352725,7.92 7.92,12.024375 7.92,17.086575 C7.92,19.9716 9.359625,22.544775 11.6094,24.224475 L11.6094,27.72 L14.98035,25.87035 C15.8796,26.118675 16.8333,26.25315 17.82,26.25315 C23.287275,26.25315 27.72,22.1496 27.72,17.086575 C27.72,12.024375 23.287275,7.92 17.82,7.92 Z M18.804225,20.264475 L16.283025,17.5758 L11.36355,20.264475 L16.774725,14.52 L19.356975,17.208675 L24.2154,14.52 L18.804225,20.264475 L18.804225,20.264475 Z"
                  id="Shape"
                  fill="#FFFFFF"
                ></path>
              </g>
            </g>
          </g>
        </svg>
      );
    case "whatsapp":
      return (
        <svg width="36px" height="36px" viewBox="0 0 36 36">
          <g
            id="Symbols"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g id="Artboard" transform="translate(-104.000000, -377.000000)">
              <g id="whatsapp" transform="translate(104.000000, 377.000000)">
                <circle
                  id="bg"
                  fill="#231F20"
                  cx="17.82"
                  cy="17.82"
                  r="17.82"
                ></circle>
                <path
                  d="M7.967025,27.72 L9.3588,22.635525 C8.499975,21.147225 8.0487,19.4601 8.049525,17.730075 C8.052,12.321375 12.453375,7.92 17.86125,7.92 C20.485575,7.920825 22.949025,8.943 24.801975,10.7976 C26.6541,12.6522 27.6738,15.1173 27.6729755,17.73915 C27.6705,23.148675 23.269125,27.55005 17.86125,27.55005 C16.2195,27.549225 14.601675,27.13755 13.16865,26.35545 L7.967025,27.72 Z M13.40955,24.579225 C14.79225,25.4001 16.11225,25.8918 17.85795,25.892625 C22.35255,25.892625 26.0139,22.234575 26.0163756,17.7375 C26.018025,13.23135 22.374,9.57825 17.86455,9.5766 C13.36665,9.5766 9.707775,13.23465 9.70612405,17.7309 C9.7053,19.566525 10.2432,20.940975 11.146575,22.37895 L10.3224,25.38855 L13.40955,24.579225 Z M22.803825,20.071425 C22.742775,19.969125 22.579425,19.908075 22.333575,19.78515 C22.08855,19.662225 20.883225,19.06905 20.658,18.987375 C20.4336,18.9057 20.27025,18.86445 20.106075,19.1103 C19.942725,19.355325 19.472475,19.908075 19.32975,20.071425 C19.187025,20.234775 19.043475,20.2554 18.79845,20.132475 C18.553425,20.00955 17.763075,19.751325 16.8267,18.9156 C16.098225,18.2655 15.6057,17.462775 15.462975,17.216925 C15.32025,16.9719 15.448125,16.839075 15.570225,16.716975 C15.680775,16.60725 15.81525,16.4307 15.938175,16.28715 C16.06275,16.14525 16.103175,16.04295 16.185675,15.878775 C16.26735,15.715425 16.226925,15.571875 16.16505,15.44895 C16.103175,15.32685 15.613125,14.119875 15.40935,13.629 C15.2097,13.151325 15.007575,13.215675 14.857425,13.20825 L14.387175,13.2 C14.223825,13.2 13.958175,13.26105 13.733775,13.5069 C13.509375,13.75275 12.875775,14.3451 12.875775,15.552075 C12.875775,16.75905 13.7544,17.924775 13.8765,18.088125 C13.999425,18.251475 15.604875,20.728125 18.0642,21.7899 C18.649125,22.04235 19.106175,22.193325 19.46175,22.30635 C20.04915,22.4928 20.58375,22.4664 21.00615,22.4037 C21.477225,22.333575 22.4565,21.810525 22.6611,21.237975 C22.8657,20.6646 22.8657,20.173725 22.803825,20.071425 L22.803825,20.071425 Z"
                  id="Shape"
                  fill="#FFFFFF"
                  fillRule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </svg>
      );
    case "facebook":
      return (
        <svg width="36px" height="36px" viewBox="0 0 36 36">
          <g
            id="Symbols"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g id="Artboard" transform="translate(-104.000000, -255.000000)">
              <g id="facebook" transform="translate(104.000000, 255.000000)">
                <circle
                  id="bg"
                  fill="#231F20"
                  cx="17.82"
                  cy="17.82"
                  r="17.82"
                ></circle>
                <path
                  d="M23.28975,14.8500619 L19.8,14.8500619 L19.8,12.8700619 C19.8,11.8483819 19.88316,11.2048819 21.34737,11.2048819 L23.19669,11.2048819 L23.19669,8.05668188 C22.29678,7.96362188 21.39192,7.91808188 20.48607,7.92 C17.8002,7.92 15.84,9.56049188 15.84,12.5720719 L15.84,14.8500619 L12.87,14.8500619 L12.87,18.8100619 L15.84,18.8090719 L15.84,27.7200619 L19.8,27.7200619 L19.8,18.8070919 L22.83534,18.8061019 L23.28975,14.8500619 Z"
                  id="Path"
                  fill="#FFFFFF"
                  fillRule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </svg>
      );
    case "pinterest":
      return (
        <svg width="36px" height="36px" viewBox="0 0 36 36">
          <g
            id="Symbols"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g id="Artboard" transform="translate(-104.000000, -316.000000)">
              <g id="pinterest" transform="translate(104.000000, 316.000000)">
                <circle
                  id="bg"
                  fill="#231F20"
                  cx="17.82"
                  cy="17.82"
                  r="17.82"
                ></circle>
                <path
                  d="M17.82,7.92 C12.352725,7.92 7.92,12.3519 7.92,17.82 C7.92,22.0143 10.529475,25.59645 14.212275,27.03855 C14.12565,26.255625 14.047275,25.054425 14.246925,24.199725 C14.426775,23.4267 15.4077,19.2786 15.4077,19.2786 C15.4077,19.2786 15.111525,18.685425 15.111525,17.80845 C15.111525,16.43235 15.9093,15.4044 16.9026,15.4044 C17.746575,15.4044 18.15495,16.038825 18.15495,16.79865 C18.15495,17.647575 17.614575,18.91725 17.3349,20.094525 C17.101425,21.079575 17.829075,21.88395 18.800925,21.88395 C20.56065,21.88395 21.912825,20.028525 21.912825,17.350575 C21.912825,14.98035 20.210025,13.322925 17.777925,13.322925 C14.961375,13.322925 13.308075,15.43575 13.308075,17.6187 C13.308075,18.469275 13.6356,19.38255 14.0448,19.87755 C14.12565,19.975725 14.1372,20.06235 14.113275,20.162175 L13.83855,21.284175 C13.794825,21.465675 13.695,21.50445 13.5069,21.417 C12.270225,20.84115 11.4972,19.033575 11.4972,17.581575 C11.4972,14.45895 13.76595,11.590425 18.038625,11.590425 C21.4731,11.590425 24.141975,14.0382 24.141975,17.3085 C24.141975,20.7207 21.9912,23.4663 19.0047,23.4663 C18.0015,23.4663 17.058525,22.945725 16.73595,22.32945 L16.11885,24.683175 C15.895275,25.54365 15.2922,26.621925 14.88795,27.278625 C15.81525,27.5649 16.799475,27.72 17.82,27.72 C23.287275,27.72 27.72,23.287275 27.72,17.82 C27.72,12.3519 23.287275,7.92 17.82,7.92 Z"
                  id="Path"
                  fill="#FFFFFF"
                  fillRule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </svg>
      );
    case "copy":
      return (
        <svg width="36px" height="36px" viewBox="0 0 36 36">
          <g
            id="Symbols"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g id="Artboard" transform="translate(-104.000000, -133.000000)">
              <g id="copy-link" transform="translate(104.000000, 133.000000)">
                <circle
                  id="bg"
                  fill="#231F20"
                  cx="17.82"
                  cy="17.82"
                  r="17.82"
                ></circle>
                <path
                  d="M19.241475,23.3095506 L16.263225,26.2869756 C14.352525,28.1968506 11.26125,28.1968506 9.351375,26.2869756 C8.427375,25.3646256 7.92,24.1370256 7.92,22.8318756 C7.92,21.5267256 8.427375,20.2991256 9.35055,19.3759506 L13.365,15.3623256 C15.307875,13.4194506 18.40905,13.4961756 20.276025,15.3623256 C20.64975,15.7360506 20.944275,16.1650506 21.17445,16.6221006 L19.860225,17.9355006 C19.711725,17.4297756 19.447725,16.9545756 19.064925,16.5726006 C17.870325,15.3780006 15.822675,15.3268506 14.57775,16.5717756 L14.576925,16.5734256 L10.56165,20.5870506 C9.32415,21.8237256 9.32415,23.8383756 10.56165,25.0750506 C11.813175,26.3265756 13.827,26.3026506 15.0513,25.0750506 L17.051925,23.0752506 C17.87115,23.3095506 18.5295,23.3516256 19.241475,23.3095506 Z M19.3743,9.3522006 L16.42575,12.3024006 C17.124525,12.2611506 17.791125,12.3024006 18.614475,12.5358756 L20.5887,10.5649506 C21.82455,9.3258006 23.8392,9.3274506 25.0767,10.5641256 C26.328225,11.8164756 26.30265,13.8303006 25.0767,15.0537756 L21.091125,19.0393506 L21.08865,19.0410006 C19.9023,20.2265256 17.8827,20.3214006 16.601475,19.0393506 C16.21125,18.6483006 15.95385,18.1797006 15.812775,17.6838756 L15.743475,17.7399756 L14.49195,18.9898506 C14.72295,19.4485506 15.015825,19.8767256 15.38955,20.2504506 C17.241675,22.1025756 20.34285,22.2090006 22.3014,20.2504506 L26.2878,16.2648756 C28.19685,14.3541756 28.1985,11.2637256 26.286975,9.3538506 C24.37545,7.4390256 21.2817,7.4456256 19.3743,9.3522006 L19.3743,9.3522006 Z"
                  id="Shape"
                  fill="#FFFFFF"
                  fillRule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </svg>
      );
    case "twitter":
      return (
        <svg width="36px" height="36px" viewBox="0 0 36 36">
          <g
            id="Symbols"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g id="Artboard" transform="translate(-104.000000, -194.000000)">
              <g id="twitter" transform="translate(104.000000, 194.000000)">
                <circle
                  id="bg"
                  fill="#231F20"
                  cx="17.82"
                  cy="17.82"
                  r="17.82"
                ></circle>
                <path
                  d="M30.572,11.1716145 C29.7415385,11.5402905 28.849004,11.7885825 27.912266,11.900502 C28.8687545,11.3277375 29.603285,10.420155 29.9484485,9.33858 C29.054033,9.869022 28.062746,10.254627 27.007505,10.4624775 C26.1638765,9.562419 24.959096,9 23.627348,9 C20.6374985,9 18.4404905,11.789523 19.1157695,14.6853225 C15.268184,14.49252 11.85605,12.64914 9.5715755,9.8473905 C8.3583305,11.928717 8.942381,14.6514645 11.003957,16.0302375 C10.245914,16.0057845 9.531134,15.797934 8.9075825,15.4508895 C8.8567955,17.59617 10.394513,19.603197 12.621617,20.0499345 C11.9698505,20.2267485 11.256011,20.2681305 10.529945,20.1289365 C11.118698,21.9685545 12.828527,23.306886 14.856245,23.344506 C12.90941,24.8709375 10.456586,25.5528 8,25.263126 C10.0493495,26.5770045 12.484304,27.343512 15.098894,27.343512 C23.696945,27.343512 28.5546275,20.0819115 28.2611915,13.568949 C29.1659525,12.9153015 29.95127,12.099888 30.572,11.1716145 Z"
                  id="Path"
                  fill="#FFFFFF"
                  fillRule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </svg>
      );
    default:
      return null;
  }
};

export default ShareIcons;
